module.exports = __webpack_public_path__ + "img/edelmann_group.eb7defed.svg";